import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/to-be-past-explanation';

const mainimage = '/Images/tobe-past1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "tobepast" },
];

const ToBePast = () => (
  <GrammarPageLayout
    level="A1"
    title="To Be Past"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Exercises: “To Be” Past"
    seoDescription="Master the past simple of 'to be' (was, were) with clear examples and practice exercises for A1 level."
    relatedCategory="grammar-exercises"
    relatedLevel="A1"
  />
);

export default ToBePast;

